import React, {useState} from 'react';
import {Button, Card, Col, Divider, Form, Input, InputNumber, Row, Select, Space, Upload} from 'antd';
import {SaveOutlined} from '@ant-design/icons';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import {useApiCreateAdminProduct} from "@/api/product";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import UploadCMP from "@/components/upload";
import TaggableSelect from "@/components/select/apiSelect";
import toFaNumber from "@/lib/utils/number";
import {useApiSearchAdminTopics} from "@/api/topic";
import {useNavigate} from "react-router-dom";

const { TextArea } = Input;
const { Dragger } = Upload;

const ProductStatusEnum = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    ARCHIVED: 'archived'
};

const ProductGenderEnum = {
    MALE: 'male',
    FEMALE: 'female',
    ALL: 'all'
};



const ProductDeliverToEnum = {
    USER: 'user',
    TEACHER: 'teacher',
    ALL: 'all'
};

function AdminProductCreate(props) {
    const [form] = Form.useForm();

    const [file, setFile] = useState()
    const [topics, setTopics] = useState([]);
    const [selectedTopics, setSelectedTopics] = useState([]);
    const navigate = useNavigate();
    const {mutate: createProduct, isPending} = useApiCreateAdminProduct();


    const handleSubmit = async (values) => {

        createProduct({
            ...values,
            file_id: file?.file?.response?.data?.id,
            topic_ids: topics,
        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)

                form.resetFields();

                setSelectedTopics([]);
                navigate(URLS.admin.products.list);
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        });
    };

    const statusOptions = [
        { label: 'پیش‌نویس', value: ProductStatusEnum.DRAFT },
        { label: 'منتشر شده', value: ProductStatusEnum.PUBLISHED },
        { label: 'بایگانی شده', value: ProductStatusEnum.ARCHIVED },
    ];

    const genderOptions = [
        { label: 'مردانه', value: ProductGenderEnum.MALE },
        { label: 'زنانه', value: ProductGenderEnum.FEMALE },
        { label: 'هردو', value: ProductGenderEnum.ALL },
    ];

    const deliverToOptions = [
        { label: 'خود دانش آموز', value: ProductDeliverToEnum.USER },
        { label: 'مربی', value: ProductDeliverToEnum.TEACHER },
        { label: 'هردو', value: ProductDeliverToEnum.ALL },
    ];

    const topicOptions = topics.map(topic => ({
        label: topic.name,
        value: topic.id,
    }));

    return (
        <AdminLayout pageTitle={'ثبت محصول'} backTo={URLS.admin.products.list}>


                <Card
                    className="shadow-lg rounded-xl"

                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        className="space-y-4"
                        initialValues={{
                            status: ProductStatusEnum.DRAFT,
                            gender: ProductGenderEnum.ALL,
                        }}
                    >
                        <Row gutter={24}>
                            {/* عنوان محصول */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="title"
                                    label="عنوان محصول"
                                    rules={[
                                        { required: false },
                                        { type: 'string', message: 'عنوان باید متن باشد' },
                                    ]}
                                    className="mb-4"
                                >
                                    <Input
                                        placeholder="عنوان محصول را وارد کنید"
                                        size="medium"
                                        className="rounded-lg"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="deliver_to"
                                    label="تحویل به"
                                    rules={[
                                        { required: false },
                                        { type: 'string', message: 'وضعیت باید متن باشد' },
                                    ]}
                                    className="mb-4"
                                >
                                    <Select
                                        options={deliverToOptions}
                                        placeholder="دریافت کننده  را انتخاب کنید"
                                        size="medium"
                                        className="rounded-lg"
                                    />
                                </Form.Item>
                            </Col>

                            {/* وضعیت */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="status"
                                    label="وضعیت"
                                    rules={[
                                        { required: false },
                                        { type: 'string', message: 'وضعیت باید متن باشد' },
                                    ]}
                                    className="mb-4"
                                >
                                    <Select
                                        options={statusOptions}
                                        placeholder="وضعیت را انتخاب کنید"
                                        size="medium"
                                        className="rounded-lg"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* توضیحات */}
                        <Form.Item
                            name="description"
                            label="توضیحات"
                            rules={[
                                { required: false },
                                { type: 'string', message: 'توضیحات باید متن باشد' },
                            ]}
                            className="mb-4"
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder="توضیحات محصول را وارد کنید"
                                className="rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            name="deliver_text"
                            label="محل تحویل"
                            rules={[
                                { required: false },
                                { type: 'string', message: 'محل تحویل باید متن باشد' },
                            ]}
                            className="mb-4"
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder="این متن در پایین برگه تحویل قرار خواهد گرفت ..."
                                className="rounded-lg"
                            />
                        </Form.Item>

                        <Row gutter={24}>
                            {/* قیمت خرید */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="buy_price"
                                    label="قیمت خرید"
                                    rules={[
                                        { required: false },
                                        { type: 'integer', message: 'قیمت خرید باید عدد صحیح باشد' },

                                    ]}
                                    className="mb-4"
                                >
                                    <InputNumber
                                        className="w-full rounded-lg"
                                        size="medium"
                                        placeholder="قیمت خرید به تومان"
                                        min={0}
                                        step={1000}
                                        suffix={'تومان'}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    />
                                </Form.Item>
                            </Col>

                            {/* قیمت فروش */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="price"
                                    label="قیمت فروش"
                                    rules={[
                                        { required: false },
                                        { type: 'integer', message: 'قیمت فروش باید عدد صحیح باشد' },

                                    ]}
                                    className="mb-4"
                                >
                                    <InputNumber
                                        className="w-full rounded-lg"
                                        size="medium"
                                        placeholder="قیمت فروش به تومان"
                                        min={0}
                                        step={1000}
                                        suffix={'تومان'}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            {/* جنسیت */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="gender"
                                    label="جنسیت"
                                    rules={[
                                        { required: false },
                                        { type: 'string', message: 'جنسیت باید متن باشد' },
                                    ]}
                                    className="mb-4"
                                >
                                    <Select
                                        options={genderOptions}
                                        placeholder="جنسیت را انتخاب کنید"
                                        size="medium"
                                        className="rounded-lg"
                                    />
                                </Form.Item>
                            </Col>

                            {/* تاپیک‌ها */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="topic_ids"

                                    rules={[
                                        { required: false },
                                        { type: 'array', message: 'تاپیک‌ها باید آرایه باشند' },
                                    ]}
                                    className="mb-4"
                                >
                                    <TaggableSelect name={'grade-search'} className={'mt-2'}
                                                    label={'فعال برای مقاطع تحصیلی'}
                                                    searchFn={useApiSearchAdminTopics}
                                                    onChange={setTopics}
                                                    values={topics}
                                                    render={(item) => {
                                                        return toFaNumber(item.id) + ' - ' + item.title
                                                    }}></TaggableSelect>
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* آپلود فایل */}
                        <Form.Item
                            name="file_id"
                            label="فایل محصول"
                            rules={[
                                { required: false },
                                { type: 'integer', message: 'شناسه فایل باید عدد باشد' },
                            ]}
                            className="mb-4"
                        >
                          <UploadCMP dragMode={true} afterUploadFn={setFile} />
                        </Form.Item>

                        <Divider />

                        {/* دکمه‌های عملیات */}
                        <Form.Item className="mb-0">
                            <Space className="w-full justify-end" size="middle">

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isPending}
                                    icon={<SaveOutlined />}

                                    size="medium"
                                >
                                    {isPending ? 'در حال ثبت...' : 'ثبت محصول'}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Card>
        </AdminLayout>


    );
}

export default AdminProductCreate;

